<footer class="app-footer" [ngClass]="styleClass" id="footer">
  @if (displayBackEndInfo) {
    <div class="app-footer__meta">
      <span>
        BankNBox <b>{{ versions.LOS }}</b> | {{ hash }}
      </span>
      @if (versions.fineract.version) {
        <span class="app-footer__sep">|</span>
        <span>
          {{ "labels.text.Fineract" | translate }}
          <b>{{ versions.fineract.version }}</b> | {{ versions.fineract.hash }}
        </span>
      }
      <span class="app-footer__sep">|</span>
      <span>{{ "labels.inputs.Server" | translate }}: {{ server }}</span>
      @if (isBusinessDateDefined) {
        <span class="app-footer__sep">|</span>
        <span>
          {{ "labels.text.Current Business Date" | translate }}:
          <b class="business-date">{{
            businessDate | date: "EEEE, MMMM dd, y"
          }}</b>
        </span>
      }
    </div>
  }
  <p class="app-footer__copy">
    © {{ currentYear }} BankNBox. All rights reserved.
    <span class="app-footer__compliance">
      SOC 2 Type 2 | PCI DSS compliant | PVI PA DSS | PCI MPoC | PCI PTS
      certified
    </span>
  </p>
</footer>
